export default __webpack_public_path__ + "static/media/Ballroll_00161.d93209c2.png";